module.exports = __webpack_public_path__ + "img/9788932916613.cb0aa723.jpg";